import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ADMIN_KEY = "naavi_admin_token";
const PARENT_KEY = "naavi_parent_token";

export const adminAuth = {
  get: () => localStorage.getItem(ADMIN_KEY),
  set: (t) => localStorage.setItem(ADMIN_KEY, t),
  clear: () => localStorage.removeItem(ADMIN_KEY),
};
export const parentAuth = {
  get: () => localStorage.getItem(PARENT_KEY),
  set: (t) => localStorage.setItem(PARENT_KEY, t),
  clear: () => localStorage.removeItem(PARENT_KEY),
};

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const t = adminAuth.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
adminApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      adminAuth.clear();
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(e);
  }
);

export const parentApi = axios.create({ baseURL: API });
parentApi.interceptors.request.use((config) => {
  const t = parentAuth.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
parentApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      parentAuth.clear();
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/parent/login")) {
        window.location.href = "/parent/login";
      }
    }
    return Promise.reject(e);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
